export const PIPELINE_PARTICIPANT_ROLES = ['associate', 'setter', 'closer'];
export const PIPELINE_LEADERSHIP_ROLES = ['manager', 'admin', 'super_admin'];

export function isPipelineParticipant(role) {
  return PIPELINE_PARTICIPANT_ROLES.includes(role);
}

export function isPipelineLeadership(role) {
  return PIPELINE_LEADERSHIP_ROLES.includes(role);
}

/** Default All/My Team filter: managers start on My Team; admin/super_admin on All. */
export function defaultTeamScope(role) {
  return role === 'manager' ? 'my_team' : 'all';
}

export function isPipelineAdminRole(role) {
  return role === 'admin' || role === 'super_admin';
}

export function canEditLaunchForAssociate(role, associateId, viewerId, teamUserIds = []) {
  if (!associateId || !viewerId) return false;
  if (associateId === viewerId) return true;
  if (isPipelineAdminRole(role)) return true;
  return (teamUserIds || []).includes(associateId);
}

export const LAUNCH_TYPE_LABELS = {
  personal_start: 'Personal Start',
  personal_post_license: 'Post-License',
  support_teammate: 'Support Teammate',
};

export const LAUNCH_STATUS_LABELS = {
  not_started: 'Not started',
  scheduled: 'Scheduled',
  completed: 'Completed',
};

export const LAUNCH_STEP_META = [
  {
    step_type: 'flyer',
    step_number: 1,
    label: 'Flyer',
    title: 'Flyer Builder',
    description: 'Generate your branded launch flyer with your name, date, and registration link.',
    action: 'Mark flyer done',
    doneAction: 'View flyer',
  },
  {
    step_type: 'crm_invite',
    step_number: 2,
    label: 'CRM List & Invite',
    title: 'CRM List & Invite',
    description: 'Share your personal invite link once your manager has scheduled this launch\'s event.',
    action: 'Mark invites sent',
    doneAction: 'Manage list',
  },
  {
    step_type: 'remind_confirm',
    step_number: 3,
    label: 'Remind & Confirm',
    title: 'Remind & 24hr Confirm',
    description: 'Send a reminder now, then a confirmation 24 hours before the event to lock in attendance.',
    action: 'Send reminders',
    doneAction: 'Reminders sent',
  },
  {
    step_type: 'event_day',
    step_number: 4,
    label: 'Event Day',
    title: 'Event Day',
    description: 'Your manager schedules the live event. When it is linked, the date and status show here.',
    action: 'Mark event complete',
    doneAction: 'Event complete',
  },
  {
    step_type: 'follow_up',
    step_number: 5,
    label: 'Follow-Up',
    title: 'Follow-Up Tracker',
    description: '24/48hr follow-up, send the survey, set 1:1 meetings, and ask attendees for referrals.',
    action: 'Mark follow-up done',
    doneAction: 'Follow-up done',
  },
];

export const TOP25_CATEGORIES = [
  {
    key: 'trust_respect',
    label: 'Trust & Respect You',
    shortLabel: 'Trust & Respect',
    target: 5,
    description: 'People who already trust and respect you personally.',
  },
  {
    key: 'center_of_influence',
    label: 'Centers of Influence',
    shortLabel: 'Center of Influence',
    target: 5,
    description: 'People others already go to for advice.',
  },
  {
    key: 'last_10_contacted',
    label: 'Last 10 Contacted',
    shortLabel: 'Last 10 Contacted',
    target: 10,
    description: 'Last 10 people you texted, called, or engaged with on social.',
  },
  {
    key: 'entrepreneurship',
    label: 'Entrepreneurship & Business',
    shortLabel: 'Entrepreneurship',
    target: 5,
    description: 'People building or running their own business.',
  },
  {
    key: 'money_conversations',
    label: 'Talk to About Money / Finances',
    shortLabel: 'Money Conversations',
    target: 5,
    description: 'People you already have money or finance conversations with.',
  },
];

export const ACADEMY_STATUS_LABELS = {
  invited: 'Invited',
  attended_summary_class: 'Attended summary class',
  offered_1on1: 'Offered 1:1',
  offered_full_class: 'Offered full class',
  followed_up: 'Followed up',
  fna_scheduled: 'FNA scheduled',
  client: 'Client',
};

export function launchStepMeta(stepType) {
  return LAUNCH_STEP_META.find((s) => s.step_type === stepType) || LAUNCH_STEP_META[0];
}

export function categoryLabel(key) {
  return TOP25_CATEGORIES.find((c) => c.key === key)?.shortLabel || key;
}

export function pickActiveLaunch(launches) {
  const list = launches || [];
  return list.find((row) => row.status !== 'completed') || null;
}
